import React from 'react';

const LoaderBlockContent = () => (
    <svg className='spinner' width='38px' height='38px' viewBox='0 0 66 66' xmlns='http://www.w3.org/2000/svg'>
        <circle fill='none' stroke='#eeeeee' strokeWidth='12' cx='33' cy='33' r='26'></circle>
        <circle className='spinner__path' fill='none' strokeWidth='12' cx='33' cy='33' r='26'></circle>
    </svg>
);

export default LoaderBlockContent;